import React, {Component} from 'react';
import {connect} from "react-redux";
import MaterialIcon from '../../MaterialIcon';
import {hideModalContent, showModalContent} from "../../../actions/nodeEditorPanelActions";

import {clickedNodeAction} from '../../../actions/clickedNodeActions';

class PanelHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nodeTitle: this.props.clickedNodeInfo.name,
            title: this.props.node.nodeName === "predictor_first_block" ? "Predictor First Block" : this.props.node.title
        };
        this.handleChangeInput = this.handleChangeInput.bind(this);
    }
    handleChangeInput(e){
        const value = e.target.value === ' ' ? '' : e.target.value;
        this.setState(
            {[e.target.name]: value},
            () => {
                const clickedNodeInfo = this.props.clickedNodeInfo;
                var obj = Object.assign({}, clickedNodeInfo);
                obj.extras.name = value;
                this.props.clickedNodeAction(obj);
            }
        );
    }
    render() {
        const nodeIcon = () => {
            if(this.props.node.nodeName === 'output')
                return <MaterialIcon icon="fingerprint" size={24}/>
            return <MaterialIcon icon="dashboard" size={24}/>
        }
        return (
            <div className="control-panel-wrapper">
                <div className={"notes-button " + this.props.node.sectionType}>
                    {nodeIcon()}
                    <span>{this.state.title}</span>
                </div>
                <form className="node-title">
                    <input onChange={(e)=>this.handleChangeInput(e)} className="editable-node-title" name="nodeTitle" value={this.state.nodeTitle} />
                </form>
                <div className={this.props.content ? "setup-button" : "setup-button disabled"} onClick={() => this.props.content ? this.props.hideModalContent(this.props.node) : this.props.showModalContent(this.props.node)}>
                    <MaterialIcon icon="settings" size={24}/>
                    <span>Setup</span>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        content: state.modalInfo.content,
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo
    }
}
export default connect(mapStateToProps, {showModalContent, hideModalContent, clickedNodeAction})(PanelHeader);